import styled from 'styled-components';

import CopyButton from 'basics/buttons/CopyButton';

import { flexColumn, flexRowSpaceBetween, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS, FONT_SIZE } from 'styles/style-constants';

export const SummaryCards = styled.dl`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.6rem;
    margin: 0 0 3.2rem;

    ${respondDown(Breakpoints.sm)`
        grid-template-columns: repeat(2, minmax(0, 1fr));
    `}
`;

export const SummaryCard = styled.div`
    ${flexColumn};
    align-items: flex-start;
    justify-content: center;
    gap: 0.4rem;
    padding: 2.4rem;
    min-width: 0;
    border-radius: 2.4rem;
    background: ${COLORS.insetBackground};

    ${respondDown(Breakpoints.sm)`
        padding: 1.6rem;

        &:last-child {
            grid-column: 1 / -1;
        }
    `}
`;

export const SummaryLabel = styled.dt`
    ${FONT_SIZE.md};
    line-height: 1.8rem;
    color: ${COLORS.textGray};
`;

export const SummaryValue = styled.dd`
    display: flex;
    align-items: center;
    min-height: 2.8rem;
    margin: 0;
    ${FONT_SIZE.md};
    font-weight: 700;
    color: ${COLORS.textTertiary};
`;

export const Details = styled.dl`
    ${flexColumn};
    margin: 0;
`;

export const DetailRow = styled.div`
    ${flexRowSpaceBetween};
    align-items: center;
    gap: 1.6rem;
    min-height: 4.8rem;
    ${FONT_SIZE.md};

    ${respondDown(Breakpoints.xs)`
        ${FONT_SIZE.sm};
        gap: 0.8rem;
    `}
`;

export const DetailLabel = styled.dt`
    color: ${COLORS.textGray};
    flex-shrink: 0;
    max-width: 55%;
`;

export const DetailValue = styled.dd`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.4rem;
    min-width: 0;
    margin: 0;
    text-align: right;
    color: ${COLORS.textTertiary};
    white-space: nowrap;

    & > :last-child {
        flex-shrink: 0;
    }
`;

export const CopyPoolId = styled(CopyButton)`
    font-size: inherit;
    line-height: inherit;
`;
